module.exports = __webpack_public_path__ + "img/12_dice[11].b41220af.png";